module.exports = __webpack_public_path__ + "static/media/mobile-product-description-row-bg.7aba9434.svg";